import { Point } from 'models';

interface Props {
    points: Point[];
    radius?: number;
}

export const roundedPath = ({ points, radius: r = 8 }: Props): string => {
    let path = '';

    // Filter duplicate points
    const points_ = points.filter((point, index) => {
        const { x, y } = point;

        const { x: x_, y: y_ } = points[index - 1] || {};

        return x !== x_ || y !== y_;
    });

    for (let i = 0; i < points_.length; i++) {
        const { x, y } = points_[i];

        if (i === 0) {
            path += `M ${x} ${y} `;
        } else if (i === points_.length - 1) {
            path += `L ${x} ${y} `;
        } else {
            const { x: x_, y: y_ } = points_[i - 1];

            const { x: x__, y: y__ } = points_[i + 1];

            if (x__ !== x_ && y__ !== y_) {
                const dx = x - x_ !== 0 ? ((x - x_) / Math.abs(x - x_)) * r : 0;
                const dy = y - y_ !== 0 ? ((y - y_) / Math.abs(y - y_)) * r : 0;

                const dx_ = x__ - x_ !== 0 ? ((x__ - x_) / Math.abs(x__ - x_)) * r : 0;
                const dy_ = y__ - y_ !== 0 ? ((y__ - y_) / Math.abs(y__ - y_)) * r : 0;

                const sweep = (x - x_) * (y__ - y_) - (y - y_) * (x__ - x_) > 0 ? 1 : 0;

                path += `L ${x - dx} ${y - dy} a ${r} ${r} 0 0 ${sweep} ${dx_} ${dy_} `;
            } else {
                path += `L ${x} ${y} `;
            }
        }
    }

    return path.trim();
};
